module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMDlhMDAiIGQ9Ik0wIDM4My45OTNoNTExLjk5M3YxMjhIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiMwMGYiIGQ9Ik0wIDEyOC4wMDFoNTExLjk5M3YxMjguMDAxSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSJyZWQiIGQ9Ik0wIDBoNTExLjk5M3YxMjguMDAxSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmYwIiBkPSJNMCAyNTUuOTkyaDUxMS45OTN2MTI4SDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/mu.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/mu.svg
// module chunks = 0